import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import { change } from 'redux-form'

import { FORM_NAME } from '@cinch/oxd-containers/dealer-listing-filters/src'
import { actions as vehicleActions, selectors as vehicleSelectors } from '@cinch/oxd-redux/dealer-vehicles/src'

import SearchComponent from '../components/search'

export const mapStateToProps = (state: any) => {
  const searchPending = vehicleSelectors.getPredicate(state).searchStatus.isPending

  return { searchPending }
}

export const mapDispatchToProps = (dispatch: Dispatch<any>) => ({
  onSubmit: ({ search }: { search: string }): Promise<any> => {
    if (search) {
      dispatch(change(FORM_NAME, 'query', search))
      dispatch(vehicleActions.search(search))
    }

    return Promise.resolve()
  },
})

export default connect<{ searchPending: boolean }, { onSubmit: any }, any>(
  mapStateToProps,
  mapDispatchToProps,
)(SearchComponent)
